/*!
 * tags js
 *
 * @deps masonry
 */

const masonryTagsExist = document.getElementsByClassName( 'js-masonry-tags' ).length;

document.addEventListener( 'readystatechange', function ( e ) {
	if ( masonryTagsExist ) {
		const masonryTagArray = document.querySelectorAll( '.js-masonry-tags' );
		masonryTagArray.forEach( function ( masonryTagElement ) {
			new Masonry( masonryTagElement, {
				itemSelector: '.js-masonry-tags-item',
				horizontalOrder: true,
				gutter: 64,
				percentPosition: true,
			} );
		} );
	}
} );
